/* src/app/private/components/student/student-profile/student-profile.component.scss */
.bottom-buttons {
  background-color: var(--p-card-background);
  width: 93%;
  bottom: 0px;
  border-bottom-right-radius: 5px;
  padding-bottom: 10px;
  padding-top: 10px;
}
.p-avatar img {
  object-fit: cover;
}
/*# sourceMappingURL=student-profile.component.css.map */
